import { Injectable } from '@angular/core';
import { HybridAppService } from '@edassist/common';
import { AuthenticationService } from '../services/auth/auth.service';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class HybridAuthGuard {
	constructor(
		private readonly authenticationService: AuthenticationService,
		private readonly hybridAppService: HybridAppService
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		if (this.authenticationService.isLoggedIn) {
			// logged in so return true
			return true;
		}
		// get the url path trying to be accessed
		const redirectURL = route['_routerState'].url;
		this.hybridAppService.navigateToBaseLogin({ redirectURL });

		return false;
	}
}
